import React, {Component} from 'react';

import FavoriteBanner from '../estate/favoriteBanner';

class FavBannerSlider extends Component {

    constructor(props) {
        super(props)
        const favEstates = this.props.estates.filter(estate => estate.coup_de_coeur._text === '1')
        this.state = {
            currSlide: 0,
            usedNavigation: false,
            totSlides: favEstates.length
        }
    }

    componentDidMount(){
        this.intervalId = setInterval( () => {
            this.automaticSlideControl()
        }, 5000);
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    automaticSlideControl() {
        if(this.state.usedNavigation) {
            this.setState({
                ...this.state,
                usedNavigation: false
            })
        } else {
            this.handleNext(false)
        }
    }

    handlePrev(isManual) {
        if(this.state.currSlide === 0) {
            this.setState({
                ...this.state,
                usedNavigation: isManual,
                currSlide: this.state.totSlides-1
            })
        } else {
            this.setState({
                ...this.state,
                usedNavigation: isManual,
                currSlide: this.state.currSlide-1
            })
        }
    }

    handleNext(isManual) {
        if(this.state.currSlide < this.state.totSlides-1) {
            this.setState({
                ...this.state,
                usedNavigation: isManual,
                currSlide: this.state.currSlide+1
            })
        } else {
            this.setState({
                ...this.state,
                usedNavigation: isManual,
                currSlide: 0
            })
        }
    }

    render(){
        const favEstates = this.props.estates.filter(estate => estate.coup_de_coeur._text === '1')
        const calcWidth = favEstates.length + '00vw';

        return (
            <div className="favBanner-wrapper">
                <div className="prev" onClick={() => this.handlePrev(true)}><i className="fa fa-angle-left" /></div>
                <div className="next" onClick={() => this.handleNext(true)}><i className="fa fa-angle-right" /></div>
                <div className="favBanner-slider" style={{width: calcWidth, marginLeft: "-"+this.state.currSlide+"00vw"}}>
                    {
                        favEstates.map(estate => {
                            return (
                                <FavoriteBanner key={estate.id._text} estate={estate}/>
                            )
                        })
                    }
                </div>
            </div>
        );
    }
}

export default FavBannerSlider;
